/**
 * Auth Drawer Component
 * Handles opening and closing the auth drawer
 */

if (!window.Eurus.loadedScript.has('auth-drawer.js')) {
  window.Eurus.loadedScript.add('auth-drawer.js');

  let isSelectedInEditor = false;

  requestAnimationFrame(() => {
    window.addEventListener('alpine:init', () => {
      Alpine.data('authDrawer', () => ({
        drawerState: false,
        init() {
          this.registerEventListeners();

          if (Shopify.designMode && isSelectedInEditor) this.openDrawer();
        },

        registerEventListeners() {
          this.listeners = new AbortController();
          const { signal } = this.listeners;

          window.addEventListener('eurus:auth:drawer-toggle', () => this.handleDrawerToggle(), { signal });

          if (Shopify.designMode) {
            document.addEventListener('shopify:section:select', (event) => {
              if (!event.target.contains(this.$el)) return;
              isSelectedInEditor = true;
              this.openDrawer();
            }, { signal });
            document.addEventListener('shopify:section:deselect', (event) => {
              if (!event.target.contains(this.$el)) return;
              isSelectedInEditor = false;
              this.closeDrawer();
            }, { signal });
            document.addEventListener('shopify:section:unload', (event) => {
              if (!event.target.contains(this.$el)) return;
              this.listeners.abort();
              this.closeDrawer();
            }, { signal });
          }
        },

        isDrawerOpen() {
          return this.drawerState;
        },

        handleDrawerToggle() {
          if (this.isDrawerOpen()) {
            this.closeDrawer();
          } else {
            this.openDrawer();
          }
        },

        openDrawer() {
          this.drawerState = true;
          document.body.style.overflow = 'hidden';
          this.$nextTick(() => {
            Alpine.store('xFocusElement').trapFocus(this.$refs.content, this.$refs.close);
          });
        },

        closeDrawer() {
          this.drawerState = false;
          document.body.style.overflow = '';
          Alpine.store('xFocusElement').releaseContainer(this.$refs.content);
        },
      }));
    });
  });
}
